import React from 'react'
import {Link } from "react-router-dom";
import Wdata from '../Data/Wdata'
function Nav1() {
  return (
    <div>
          <div className="border mb-3">
            <img
              className="w-100 p-2"
              src="https://html.dynamiclayers.net/dl/news24/img/banner-2.jpg"
            />
          </div>
          <a
            target="_blank"
            href="https://www.booked.net/weather/kathmandu-5536"
          >
            <img
              className="w-100 px-3 py-1 mb-3"
              src="https://w.bookcdn.com/weather/picture/3_5536_1_1_137AE9_250_ffffff_333333_08488D_1_ffffff_333333_0_6.png?scode=37429&domid=w209&anc_id=62558"
              alt="booked.net"
            />
          </a>
          <div className="border p-2 mb-3">
            {Wdata.slice(0,4).map((a) => (
              <>
                <div className="d-flex border my-2">
                  <div className="flex-shrink-0">
                    <img
                      className="object-fit-cover"
                      width={100}
                      height={100}
                      src={a.img}
                    />
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <a href="">
                      <p className="text-dark pe-0">{a.description}</p>
                    </a>
                  </div>
                </div>
              </>
            ))}
          </div>
          <ul class="list-group">
              <li class="list-group-item py-3">
                <h3 className="fw-bold">NEWS CATEGORY</h3>
              </li>
              <Link to="/world" className="fw-semibold"><li class="list-group-item py-3 news">WORLD</li></Link>
              <Link to="#" className="fw-semibold"><li class="list-group-item py-3 news">TRAVEL</li></Link>
              <Link to="#" className="fw-semibold"><li class="list-group-item py-3 news">FOODS</li></Link>
              <Link to="#" className="fw-semibold"><li class="list-group-item py-3 news">CREATIVE</li></Link>
              <Link to="#" className="fw-semibold"><li class="list-group-item py-3 news">SPORTS</li></Link>
              <Link to="#" className="fw-semibold"><li class="list-group-item py-3 news">RACING</li> </Link>
              <Link to="#" className="fw-semibold"><li class="list-group-item py-3 news">TECHNOLOGY</li></Link>
            </ul>
            <div className="border py-3 mt-3 px-3">
              <h2 className="pt-4 me-2 pb-4 fs-4 fw-bold">
                <span className="a">SUBSCRIBE NEWS24</span>
              </h2>
              <form className="d-flex pb-4" role="search">
                <input
                  className="form-control py-4"
                  type="search"
                  placeholder="Your email"
                  aria-label="Search"
                />
              </form>
              <button type="button" className=" btn dam px-4 py-3">
                Subscribe
              </button>
            </div>
        </div>
  )
}

export default Nav1
